import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { PERSISTED_SLICES } from '../persistence/persistence.registry';
import { BARCODE_CLIPBOARD_FEATURE_KEY } from './barcode-clipboard-collection.state';
import { BarcodeClipboardEffects } from './effects/barcode-clipboard.effects';
import { barcodeClipboardReducer } from './reducers/barcode-clipboard.reducer';
import { selectBarcodeClipboard } from './selectors/barcode-clipboard.selector';

/**
 * Registers the barcode clipboard store slice. Import once where `PaceCoreModule` is
 * bootstrapped, next to `UserMasterStoreModule` - the module is eagerly loaded there, so the
 * slice and its effects exist before any consumer dispatches `fetchBarcodeClipboardRequested`.
 *
 * The slice registers its projection selector with the generic persistence layer, which persists the
 * clipboard to the concurrency store under the `barcodeClipboardSlice` key. Clipboards written before
 * this slice existed live elsewhere — plain JSON under the `pace-barcode-clipboard` concurrent-usage
 * entry — and are migrated on first read, see
 * `BarcodeClipboardEffects.applyHydratedBarcodeClipboard$`.
 */
@NgModule({
    imports: [
        StoreModule.forFeature(BARCODE_CLIPBOARD_FEATURE_KEY, barcodeClipboardReducer),
        EffectsModule.forFeature([BarcodeClipboardEffects]),
    ],
    providers: [
        {
            provide: PERSISTED_SLICES,
            multi: true,
            useValue: {
                featureKey: BARCODE_CLIPBOARD_FEATURE_KEY,
                persistSelector: selectBarcodeClipboard,
            },
        },
    ],
})
export class BarcodeClipboardStoreModule {}
